import { contactsApi } from '@/lib/api/services/contacts';

/**
 * Contact-export completion notifications carry `kind: 'contact_export_result'`
 * plus `jobId` / a short-lived `fileUrl`. Clicking the bell should download
 * the file — not only navigate to /home/leads.
 *
 * Prefers a fresh presigned URL from GET /contacts/export/:jobId (1h TTL on
 * the URL stored in the notification may already have expired).
 */
export async function downloadContactExportFromNotification(
  data: Record<string, unknown> | null | undefined
): Promise<boolean> {
  if (!data || data.kind !== 'contact_export_result') return false;

  const jobId = typeof data.jobId === 'string' ? data.jobId : null;
  let fileUrl = typeof data.fileUrl === 'string' ? data.fileUrl : null;
  let filename =
    typeof data.filename === 'string' && data.filename.trim()
      ? data.filename
      : `contacts-export.${data.format === 'csv' ? 'csv' : 'xlsx'}`;

  if (jobId) {
    try {
      const status = await contactsApi.getExportStatus(jobId);
      if (status.ok && status.fileUrl) {
        fileUrl = status.fileUrl;
        if (status.filename) filename = status.filename;
      }
    } catch {
      // Fall through to stored fileUrl
    }
  }

  if (!fileUrl || !/^https?:\/\//i.test(fileUrl)) return false;

  const link = document.createElement('a');
  link.href = fileUrl;
  link.download = filename;
  link.target = '_blank';
  link.rel = 'noopener';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  return true;
}
